import { useContext, useState } from "react";
import Button from "../Forms/Button";
import { SegmentContext } from "./SegmentContext";
import { MisterIcon } from "@rtel/mister-icons";

const DemoArrayofSegments = () => {
  const currentSegmentContext = useContext(SegmentContext);
  const [isListDisplayed,setIsListDisplayed] = useState(false);
  
const handleClick = () =>{
  setIsListDisplayed(!isListDisplayed)
}

  return (
    <>
      {currentSegmentContext.segmentList.length != 0 && (
        <Button
          size={"sm"}
          styletype={"secondary"}
          onClick={handleClick}
        >
          <MisterIcon name="More" size="sm" />
        </Button>
        
      )}
      {isListDisplayed ==true && currentSegmentContext.segmentList.map(({ name } , index:number) => (
        <p key={index}>{name}</p>
      ))}

    </>
  );
};

export default DemoArrayofSegments;
